import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ecran1 from '../../assets/images/ncp/2025/ecran1.png';
import ecran1_mobile from '../../assets/images/ncp/2025/background_mobile.png';
import promo_despre_alcool from '../../assets/images/promo-despre-alcool.png';
import useMixTapanStyles from "../../styles/ncp/mix_tapan";
import banner from '../../assets/images/ncp/2025/banner_site.png';
import {paths} from "../../AppRouters";
import desktop from '../../assets/images/ncp/2025/banner_site_castigatori.png';
import mobile from '../../assets/images/ncp/2025/mobile_castigatori.png';

const HomeBannerNcp: React.FC = () => {
    const mixTapanStyle = useMixTapanStyles();
    const navigate = useNavigate();

    const handleNavigateToNcp = () => {
        navigate(paths.ncp);
    };

     return (
        <Grid container>
            <Grid item xs={12} style={{position: 'relative'}}>
                {/* Banner pentru desktop - clickabil */}
                <img 
                    src={desktop} 
                    alt={'Kozel Mix Țapăn 2025'} 
                    onClick={handleNavigateToNcp}
                    className={mixTapanStyle.bannerDesktop}
                />
                
                {/* Imaginea pentru mobile */}
                <img src={mobile} alt={'Kozel Mix Țapăn 2025'} className={mixTapanStyle.fullWidthImageMobile} onClick={handleNavigateToNcp}/>

                {/* Text și imagine - overlay DOAR pentru mobile */}
                {/* <div className={mixTapanStyle.bottomOverlayMobileOnly}>
                    <Typography className={mixTapanStyle.bottomText}>
                        Durata campaniei: <b>07.08.2025 - 01.09.2025</b>
                    </Typography>
                    <a href="https://desprealcool.ro/" target="_blank" rel="noopener noreferrer">
                        <img src={promo_despre_alcool} alt={'promo despre alcool'} className={mixTapanStyle.promoImage}/>
                    </a>
                </div> */}
                
                {/* Buton pentru navigare la NCP - DOAR pentru mobile */}
                {/* <Button 
                    onClick={handleNavigateToNcp}
                    className={mixTapanStyle.mobileButton}
                >
                    Accesează campania
                </Button> */}
            </Grid>
        </Grid>
    );
};

export default HomeBannerNcp;